import { render } from "./canvas.vue?vue&type=template&id=07cc9e36"
import script from "./canvas.vue?vue&type=script&lang=js"
export * from "./canvas.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__